import React from 'react';
import reactCSS from 'reactcss';
import icons from '../../helpers/icons';

import FacebookSelectorEmoji from './FacebookSelectorEmoji';

// Tipos
export interface FacebookSelectorProps {
  reactions?: string[];
  iconsize?: number;
  variant?: string;
  bg?: string;
  onselect?: (reaction: string) => void;
}

export const FacebookSelector: React.FC<FacebookSelectorProps> = ({
  reactions = ['like', 'love', 'haha', 'wow', 'sad', 'angry', 'eyes'],
  iconsize = 38,
  variant = 'facebook',
  bg = '#fff',
  onselect,
}) =>
{
  const isDark = document.documentElement.classList.contains('dark');
  const resolvedBg = isDark ? '#333535' : bg;
  const styles = reactCSS({
    default: {
      selector: {
        backgroundColor: resolvedBg,
        borderRadius: '50px',
        padding: '2px',
        boxShadow: isDark
          ? '0 0 0 1px rgba(255,255,255,.08), 0 2px 6px rgba(0,0,0,.5)'
          : '0 0 0 1px rgba(0, 0, 0, .05), 0 1px 2px rgba(0, 0, 0, .15)',
        display: 'flex',
      },
      icon: {
        width: `${iconsize}px`,
      },
    },
  });

  return (
    <div style={styles.selector}>
      {reactions.map(reaction => (
        <div style={styles.icon} key={reaction}>
          <FacebookSelectorEmoji
            icon={icons.find(variant, reaction)}
            label={reaction}
            onSelect={onselect}
          />
        </div>
      ))}
    </div>
  );
};

export default FacebookSelector;
